var map = {
	"./add_icon.png": 88865,
	"./allgame/active-favorite.png": 12777,
	"./allgame/all-card.png": 34595,
	"./allgame/available.png": 9528,
	"./allgame/background-left.png": 28574,
	"./allgame/background-right.png": 79160,
	"./allgame/banner-slide-left.png": 64384,
	"./allgame/banner-slide-right.png": 70608,
	"./allgame/category-background.png": 2745,
	"./allgame/default-favorite.png": 62464,
	"./allgame/disabled-heart.png": 71289,
	"./allgame/disabled-heart2.png": 90411,
	"./allgame/heart-active.png": 29891,
	"./allgame/slot-icon.png": 82951,
	"./allgame/unavailable.png": 94807,
	"./allgamelist00.png": 72211,
	"./allgamelist00_num.png": 54656,
	"./allgamelist01.png": 73290,
	"./allgamelist01_num.png": 21528,
	"./allgamelist02.png": 98972,
	"./allgamelist02_num.png": 5051,
	"./allgametap_btn.png": 96833,
	"./allgametap_btn_num.png": 54375,
	"./arrow.png": 16402,
	"./arrow/vector_left.png": 37713,
	"./arrow/vector_right.png": 62836,
	"./available_btn.png": 43915,
	"./bankname_sample1.png": 70471,
	"./banner/all_games_banner.svg": 80888,
	"./banner/banner-example.png": 73832,
	"./banner/banner-guide.png": 7390,
	"./banner/banner00.png": 1141,
	"./banner/banner00.spine.mp4": 95379,
	"./banner/banner01.png": 78748,
	"./banner/banner02.png": 31942,
	"./banner/banner03.png": 20986,
	"./banner/banner04.png": 47537,
	"./banner/banner05.png": 73207,
	"./banner/banner06.png": 18927,
	"./banner/game-list-box.png": 12136,
	"./banner/quick-join-box.png": 97634,
	"./banner/quick-join-icon.png": 82521,
	"./bg.png": 7362,
	"./check_icon.png": 26976,
	"./customerservice_img.png": 88358,
	"./delete_icon.png": 98777,
	"./dialog/alert/notify-icon.png": 1479,
	"./dialog/currency/CNY.png": 55528,
	"./dialog/currency/EUR.png": 60654,
	"./dialog/currency/HKD.png": 93090,
	"./dialog/currency/KRW.png": 37004,
	"./dialog/currency/PHP.png": 69603,
	"./dialog/currency/THB.png": 69414,
	"./dialog/currency/TWD.png": 13053,
	"./dialog/currency/USD.png": 72325,
	"./dialog/game-history/details_btn.png": 95409,
	"./dialog/game-history/game_history.png": 45819,
	"./dialog/game-history/page_num_box.png": 90048,
	"./dialog/game-history/page_num_box_on.png": 59913,
	"./dialog/game-history/play_btn.png": 4410,
	"./dialog/profile/currency.png": 94456,
	"./dialog/profile/history.png": 49608,
	"./dialog/profile/logout.png": 48110,
	"./dialog/profile/profile-change.png": 6636,
	"./dialog/profile/referral.png": 54953,
	"./dialog/profile/security.png": 41956,
	"./dialog/profile/transaction.png": 31467,
	"./dialog/profile/vip.png": 38277,
	"./dialog/terms/terms-img01.png": 52235,
	"./dialog/terms/terms-img02.png": 94928,
	"./dialog/transection/copy_icon.png": 45122,
	"./dialog/transection/deposit_again_btn.png": 66243,
	"./dialog/transection/down_arrow.png": 9430,
	"./dialog/transection/more_tap_btn.png": 53298,
	"./dice_icon.png": 25703,
	"./disable_btn.png": 463,
	"./drag_arrow.png": 61622,
	"./duofuduocai_game 1.png": 8277,
	"./duofuduocai_top 1.png": 77491,
	"./eye_activate.png": 22429,
	"./eye_disabled.png": 5804,
	"./eye_icon.png": 9632,
	"./eye_icon_no.png": 98258,
	"./favorite_icon.png": 19931,
	"./favorites_btn.png": 87058,
	"./fiat_btn.png": 84992,
	"./flag_cn.png": 30831,
	"./flag_kr.png": 73894,
	"./flag_usa.png": 58151,
	"./footer/18_icon.png": 48459,
	"./footer/bitcion_icon.png": 93452,
	"./footer/bnbcion_icon.png": 81459,
	"./footer/cats_icon.png": 15508,
	"./footer/ethereum_icon.png": 76039,
	"./footer/facebook_icon.png": 45112,
	"./footer/galze_icon.png": 1870,
	"./footer/instar_icon.png": 70468,
	"./footer/krw_icon.png": 18953,
	"./footer/line_icon.png": 88852,
	"./footer/mail_icon.png": 40453,
	"./footer/mastercard_icon.png": 29839,
	"./footer/tether_icon.png": 24007,
	"./footer/tron_icon.png": 56558,
	"./footer/usdcoin_icon.png": 84805,
	"./footer/visa_icon.png": 2627,
	"./footer/winntech_01.png": 47319,
	"./footer/x_icon.png": 65322,
	"./footer/youtube_icon.png": 20053,
	"./game-list/active-heart.png": 70978,
	"./game-list/disable-heart.png": 44035,
	"./game-list/quick-play.png": 28971,
	"./game-theme/Tian-Chi-Jin-Lu.png": 37404,
	"./game-theme/YingFuWa.png": 25179,
	"./game-theme/all-game.png": 87887,
	"./game-theme/casino-wizard.png": 1887,
	"./game-theme/coin-mouse.png": 90056,
	"./game-theme/endless-treasure.png": 94844,
	"./game-theme/fu-pots.png": 79279,
	"./game-theme/fudai-lian-lian.png": 95363,
	"./game-theme/game-theme-active.png": 61598,
	"./game-theme/hurricane-horse.png": 35528,
	"./game-theme/intervision.png": 75003,
	"./game-theme/prancing-pigs.png": 99320,
	"./game-theme/rising-fortunes.png": 69897,
	"./game-theme/singing-cats.png": 42535,
	"./game-theme/tian-phoenix.png": 23399,
	"./hamburger_btn_close.png": 70455,
	"./hamburger_btn_open.png": 97540,
	"./header/alarm.png": 41079,
	"./header/header-logo.png": 2682,
	"./header/language.png": 63187,
	"./header_bg.png": 61261,
	"./header_logo.png": 399,
	"./header_logo_bg.png": 95859,
	"./heart-active.png": 68987,
	"./heart-disabled.png": 57778,
	"./heart-icon.png": 33046,
	"./hearts-active.png": 64443,
	"./hearts-disabled.png": 48097,
	"./hearts_icon.png": 81148,
	"./hearts_icon_disable.png": 98495,
	"./hotgame_img00.png": 94003,
	"./hotgame_img01.png": 76165,
	"./hotgame_img02.png": 7306,
	"./hotgame_img03.png": 49486,
	"./idle_icon.png": 926,
	"./idle_icon02.png": 12660,
	"./ingame_bg.png": 97621,
	"./jackpot/all-jackpot.png": 52681,
	"./jackpot/jackpot-box.png": 157,
	"./jackpot/jackpot-icon.png": 13642,
	"./jackpot/jackpot-num.png": 35876,
	"./jackpot/jackpot-title.png": 45326,
	"./jackpot/jackpot01.png": 97566,
	"./jackpot/jackpot02.png": 19391,
	"./jackpot/jackpot03.png": 14582,
	"./language-icon.png": 58500,
	"./language_btn.png": 87092,
	"./lefttap_bg.png": 71470,
	"./light00.png": 74444,
	"./login/backarrow.png": 36135,
	"./login/bankname_sample0.png": 70413,
	"./login/bankname_sample1.png": 46172,
	"./login/currency_icon.png": 28555,
	"./login/deposit_btn.png": 70532,
	"./login/disable-login.png": 54478,
	"./login/error-icon.png": 43203,
	"./login/gamehistory_icon.png": 86297,
	"./login/instapay_btn.png": 94746,
	"./login/logout_icon.png": 77945,
	"./login/namechange_icon.png": 90381,
	"./login/profile_icon00.png": 88121,
	"./login/profile_icon01.png": 57805,
	"./login/profile_icon02.png": 72363,
	"./login/profile_icon03.png": 38321,
	"./login/profile_icon04.png": 66039,
	"./login/profile_icon05.png": 45857,
	"./login/profile_icon06.png": 42234,
	"./login/profile_icon07.png": 41754,
	"./login/profile_icon08.png": 38229,
	"./login/profilechange_icon.png": 5120,
	"./login/referral_icon.png": 68219,
	"./login/security_icon.png": 4487,
	"./login/sizearrow.png": 64309,
	"./login/transactions_icon.png": 99902,
	"./login/vipclass_0.png": 70352,
	"./login/vipclass_1.png": 51543,
	"./login/vipclub_icon.png": 34631,
	"./machine-icon.svg": 57154,
	"./main/5-Dragons-ultra-bottom.png": 21215,
	"./main/5-Dragons-ultra-top.png": 10152,
	"./main/5-dragons-ultra_logo.png": 1502,
	"./main/Casino-Wizard-bottom.png": 18362,
	"./main/Casino-Wizard-top.png": 36474,
	"./main/Coin-Combo-bottom.png": 52479,
	"./main/Coin-Combo-top.png": 21989,
	"./main/DFDC_Grand_logo.png": 82594,
	"./main/Double-Money-LInk-logo.png": 52840,
	"./main/Double-money-link-bottom.png": 75761,
	"./main/Double-money-link-top.png": 17535,
	"./main/Duo-Fu-Duo-Cai-bottom.png": 39105,
	"./main/Duo-Fu-Duo-Cai-top.png": 44144,
	"./main/Fudai-lian-lian-bottom.png": 31683,
	"./main/Fudai-lian-lian-top.png": 95505,
	"./main/Huff-N-More-Puff_logo.png": 17976,
	"./main/Huff-more-puff-bottom.png": 65196,
	"./main/Huff-more-puff-top.png": 13958,
	"./main/Intervision_bottom.png": 90237,
	"./main/Intervision_logo.png": 30459,
	"./main/Intervision_top.png": 19494,
	"./main/JBX_PP_bottom.png": 54916,
	"./main/JBX_PP_logo.png": 74915,
	"./main/JBX_PP_top.png": 83563,
	"./main/JBX_RF_bottom.png": 46831,
	"./main/JBX_RF_logo.png": 61992,
	"./main/JBX_RF_top.png": 76736,
	"./main/JBX_SC_bottom.png": 49223,
	"./main/JBX_SC_logo.png": 67724,
	"./main/JBX_SC_top.png": 67261,
	"./main/JEU-MAS-CCCC-Carte_logo.png": 14025,
	"./main/Slot4-bottom.png": 21965,
	"./main/Slot4-top.png": 72583,
	"./main/Slot5-bottom.png": 65946,
	"./main/Slot5-top.png": 56453,
	"./main/Slot6-bottom.png": 98256,
	"./main/Slot6-top.png": 71787,
	"./main/Tian-Chi-Jin-Lu_bottom.png": 71530,
	"./main/Tian-Chi-Jin-Lu_logo.png": 66414,
	"./main/Tian-Chi-Jin-Lu_top.png": 92213,
	"./main/ani_logo_s.gif": 26438,
	"./main/baccarat_bg.png": 5529,
	"./main/baccarat_person.png": 96135,
	"./main/baccarat_title_bg.png": 83899,
	"./main/banner01.png": 85895,
	"./main/banner02.png": 20466,
	"./main/banner03.png": 94675,
	"./main/banner04.png": 43213,
	"./main/blackjack_bg.png": 68817,
	"./main/blackjack_person.png": 91331,
	"./main/coin-mouse-logo.png": 28807,
	"./main/coin-mouse.png": 8907,
	"./main/coin_mouse_img.png": 95852,
	"./main/coin_mouse_logo.png": 76633,
	"./main/combo_bottom.png": 72897,
	"./main/eye-icon.png": 49203,
	"./main/fudailianlian_logo.png": 93971,
	"./main/fupots-logo.png": 75160,
	"./main/hamburger.png": 73971,
	"./main/header-logo.png": 73470,
	"./main/header_logo_bg.png": 14950,
	"./main/horse_bottom.png": 8484,
	"./main/hurricane-horse-logo.png": 99832,
	"./main/hurricane-horse.png": 8773,
	"./main/hurricane_horse_img.png": 43173,
	"./main/hurricane_horse_logo.png": 4211,
	"./main/jinjibaoxi_bottom.png": 16752,
	"./main/jinjibaoxi_top.png": 49300,
	"./main/jinjibaoxi_url.png": 49255,
	"./main/locked-icon.png": 56785,
	"./main/logo.png": 82236,
	"./main/menu-bar.png": 27059,
	"./main/phoenix_bottom.png": 20824,
	"./main/play-icon.png": 30166,
	"./main/racing_bg.png": 83417,
	"./main/racing_person.png": 67667,
	"./main/racing_title_bg.png": 2060,
	"./main/sicbo_bg.png": 88270,
	"./main/sicbo_dice.png": 22885,
	"./main/tian-bottom.png": 82194,
	"./main/tian-ci-jinlu_p.png": 59133,
	"./main/tian-phoenix_E.png": 65237,
	"./main/tian-phoenix_bottom.png": 76914,
	"./main/tian-phoenix_logo.png": 85372,
	"./main/tian-phoenix_top.png": 29307,
	"./main/tianchiJinlu_logo.png": 14339,
	"./main/view-button.png": 80226,
	"./main/watch-button.png": 14713,
	"./main/winnball_bg.png": 99264,
	"./main/winnball_chip.png": 3328,
	"./main/winnball_title_bg.png": 41489,
	"./main/wizard-bottom.png": 27443,
	"./main/wizard-logo.png": 262,
	"./main/wizard-top.png": 8507,
	"./main/yingfuwa-bottom.png": 14475,
	"./main/yingfuwa-logo.png": 6433,
	"./main/yingfuwa-top.png": 4634,
	"./main/zitro-fupots-bottom.png": 86013,
	"./main/zitro-fupots-top.png": 22077,
	"./main_advertisement00.png": 11837,
	"./main_advertisement01.png": 92807,
	"./main_advertisement02.png": 11232,
	"./more_btn.png": 52255,
	"./no_icon.png": 34208,
	"./notice_img00.png": 23350,
	"./notice_img01.png": 31840,
	"./play_btn.png": 93697,
	"./play_btn_box.png": 42069,
	"./play_btn_box_on.png": 82972,
	"./profile_icon.png": 48809,
	"./puzzle.jpg": 90739,
	"./quickjoin_btn.png": 36123,
	"./referraltap_btn.png": 86146,
	"./refresh.png": 34144,
	"./refresh_image.jpg": 22363,
	"./security/danger_alarm_icon.png": 92181,
	"./security/qrcode_sample.png": 15258,
	"./security/security_btn.png": 34543,
	"./select_btn.png": 74929,
	"./select_language_btn.png": 39107,
	"./send_btn.png": 15409,
	"./side-menu/cs.png": 39414,
	"./side-menu/event.png": 89134,
	"./side-menu/vip.png": 85527,
	"./signin_btn.png": 30499,
	"./signin_img.png": 49227,
	"./signup_btn.png": 39451,
	"./signup_img.png": 87761,
	"./signup_select_box.png": 61709,
	"./signup_select_box_on.png": 4561,
	"./slotgame_img00.png": 11871,
	"./slotgame_img01.png": 33909,
	"./slotgame_img02.png": 93893,
	"./slotgame_img03.png": 82381,
	"./slotgame_img04.png": 31341,
	"./slotmachine_icon.png": 70087,
	"./slotmachine_mini_icon.png": 49402,
	"./snsicon_google.png": 82760,
	"./snsicon_line.png": 35161,
	"./snsicon_x.png": 8019,
	"./state-icon.png": 99456,
	"./viptap_btn.png": 88795,
	"./wallet_btn.png": 54744,
	"./wallet_card_bg.png": 91963,
	"./x_btn.png": 18889,
	"./xgamesmini_logo.png": 88637,
	"./yellow_btn.png": 78983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;